
export const environment = {
	production: true,
	version: '1.3.6',
	baseAPI:'https://iot-devices-management-api.guglielmo.dev/dashboard',
	baseDashboard:'https://iot-devices-management.guglielmo.dev/',

};
